export default __webpack_public_path__ + "static/media/mons19.f29bbc40.jpg";